import(/* webpackMode: "eager", webpackExports: ["SignInForms"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/apps/web/app/[locale]/sign-in/forms.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/AGBA/robo-illustration/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
